import { isPVQForm } from 'helpers/form';

const defaultPsychologicalState = {
  Competence: null,
  Consultations: null,
  Diagnoses: null,
  Hospitalizations: null,
};

/**
 * Determines if Question 21 E should be rendered.
 * The following subsections must have branch values of No.
 *   - Competence
 *   - Consultations
 *   - Hospitalizations
 *   - Diagnoses
 */
export const showQuestion21E = (psychological = defaultPsychologicalState) => {
  const {
    Competence, Consultations, Diagnoses, Hospitalizations
  } = psychological;

  // We need values for everything before we can do anything
  if (!Competence || !Consultations || !Diagnoses || !Hospitalizations) {
    return false;
  }

  // We show question 21 if all other subsections have been marked with No
  return (
    Competence.IsIncompetent.value === 'No'
    && Consultations.Consulted.value === 'No'
    && Diagnoses.Diagnosed.value === 'No'
    && Hospitalizations.Hospitalized.value === 'No'
  );
};

/**
 * Determines if Existing Conditions should be rendered.
 * The following subsections are checked
 *   - Diagnoses branch question must be I don't know
 */
export const showExistingConditionsPvq = (psychological = defaultPsychologicalState) => (psychological.Diagnoses?.Diagnosed?.value === 'IDontKnow');

export const hideExistingConditions = (application = {}) => {
  const isPvq = isPVQForm(application.Settings?.formType);
  return (isPvq ? !showExistingConditionsPvq(application.Psychological) : !showQuestion21E(application.Psychological));
};
